<!-- DEV NOTE: this component is used on company settings and parts locations. Consider keep the component generic -->
<template>
	<SectionContainer
		ref="sectionContainer"
		:isExpandable="true"
		class="company-address"
	>
		<template #left>
			<h4>Address</h4>
		</template>
		<template #right>
			<div v-if="editMode">
				<Button
					className="btn--icon-only"
					iconClassName="icon-more"
					:iconBeforeLabel="true"
				/>
				<Button
					className="btn--icon-only"
					iconClassName="icon-unsaved"
					:iconBeforeLabel="true"
				/>
				<Button
					className="btn--icon-only"
					iconClassName="icon-close"
					:iconBeforeLabel="true"
					:btnClick="handleEditMode"
				/>
			</div>
			<Button
				v-if="!editMode"
				className="btn--icon-only"
				iconClassName="icon-edit"
				:iconBeforeLabel="true"
				:btnClick="handleEditMode"
			/>
		</template>
		<template #content>
			<!-- DEV NOTE: HorizontalScrolling component is not working at the moment. Update this piece after is ready -->
			<!-- <HorizontalScrolling
				:source="carouselSource"
				:component="carouselComponent"
			/> -->
			<!-- TO BE REMOVE: remove when HorizontalScrolling component is fixed -->
			<ul class="company-address__items" v-if="!editMode">
				<li v-for="(item, index) in carouselSource.items" :key="index">
					<CompanyAddressCard :item="item" />
				</li>
			</ul>
			<ul class="company-address__items-edit-mode" v-else>
				<li v-for="(item, index) in carouselSource.items" :key="index">
					<CompanyAddressCardEdit
						v-model="carouselSource.items[index]"
					/>
				</li>
			</ul>
			<Modal
				:display="true"
				:isConfirmation="true"
				v-if="closeWithOutSaving"
			>
				<template #modal-content>
					Are you sure you want to close this section without saving?
				</template>
			</Modal>
		</template>
	</SectionContainer>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';
import Button from '@/components/forms/button/button';
import Modal from '@/components/shells/modal/modals';
// import HorizontalScrolling from '@/components/shells/horizontal-scrolling/horizontal-scrolling';
import CompanyAddressCard from './company-address-card.vue';
import CompanyAddressCardEdit from './company-address-card-edit.vue';
import _ from 'lodash';

export default {
	name: 'CompanyAddress',
	components: {
		SectionContainer,
		Button,
		Modal,
		CompanyAddressCard, //comment when HorizontalScrolling is ready
		//HorizontalScrolling
		CompanyAddressCardEdit
	},
	props: {
		data: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			carouselSource: {
				totalPageCount: 1,
				countPerPage: this.data.length,
				items: _.cloneDeep(this.data),
				totalCount: this.data.length,
				page: 1
			},
			carouselComponent: CompanyAddressCard,
			closeWithOutSaving: false,
			editMode: false
		};
	},
	methods: {
		handleEditMode() {
			this.editMode = !this.editMode;
		}
	},
	watch: {
		'carouselSource.items': {
			deep: true,
			handler(newValue) {
				console.log(newValue);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.company-address {
	&__items,
	&__items-edit-mode {
		display: flex;
		gap: $gutter-lg;
		margin-bottom: $gutter-xxl;
	}

	h4 {
		margin-block-start: 0;
		margin-block-end: 0;
	}
}
</style>
